/* snoot: Versus Table. Reveals the marks when the table scrolls in, and lets phones pick which rival to compare. */
(function () {
  function init(root) {
    if (root.__svt) return;
    root.__svt = true;
    var table = root.querySelector('.svt__table'), nav = root.querySelector('[data-svt-nav]');
    if (table && nav) {
      var rivals = nav.getAttribute('data-rivals').split(','), cur = 0, x0 = null;
      var name = nav.querySelector('[data-svt-name]');
      function go(i) {
        cur = (i + rivals.length) % rivals.length;
        table.setAttribute('data-show', rivals[cur]);
        var t = nav.querySelector('[data-svt-label="' + rivals[cur] + '"]');
        if (name && t) name.textContent = t.innerHTML;
        nav.querySelectorAll('[data-svt-dot]').forEach(function (d) { d.classList.toggle('on', d.getAttribute('data-svt-dot') === rivals[cur]); });
      }
      nav.querySelectorAll('[data-svt-step]').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-svt-step'), 10)); }); });
      table.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      table.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    if (!('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.25 });
    io.observe(root);
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-svt]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
